import { useCallback } from 'react';
import { getFeatureFlags } from 'core/flow-control';
import { getQueryParams } from 'features/site-selection/common/utils/utils';
import {
    REQUEST_ID_QUERY,
    REQUEST_TYPE_QUERY,
} from 'features/offline-reports/support-requests/hooks/use-open-support-by-query-param';
import { useHistory } from 'react-router-dom';

export const useTraceSupportQueryParam = () => {
    const history = useHistory();
    const { enable_support_diff_url_ff } = getFeatureFlags();

    const clearSupportRequestInQuery = useCallback(() => {
        if (!enable_support_diff_url_ff) return;

        const queryParams = getQueryParams();

        queryParams.delete(REQUEST_TYPE_QUERY);
        queryParams.delete(REQUEST_ID_QUERY);

        history?.replace({
            pathname: history.location.pathname,
            search: queryParams.toString(),
        });
    }, [enable_support_diff_url_ff, history]);

    const setSupportRequestInQuery = useCallback(
        ({ type, requestId }) => {
            if (!enable_support_diff_url_ff) return;

            const queryParams = getQueryParams();
            queryParams.set(REQUEST_TYPE_QUERY, type);
            if (requestId) {
                queryParams.set(REQUEST_ID_QUERY, requestId);
            }

            history?.replace({
                pathname: history.location.pathname,
                search: queryParams.toString(),
            });
        },
        [enable_support_diff_url_ff, history],
    );

    return { setSupportRequestInQuery, clearSupportRequestInQuery };
};
